__turbopack_context__.v({
  "accordionItem": "AccordionItem-module-scss-module__8ZmJjW__accordionItem",
  "accordionItemHeading": "AccordionItem-module-scss-module__8ZmJjW__accordionItemHeading",
  "accordionItemParagraph": "AccordionItem-module-scss-module__8ZmJjW__accordionItemParagraph",
  "copyBlock": "AccordionItem-module-scss-module__8ZmJjW__copyBlock",
  "copyInner": "AccordionItem-module-scss-module__8ZmJjW__copyInner",
  "copyInnerHeight": "AccordionItem-module-scss-module__8ZmJjW__copyInnerHeight",
  "fade-in": "AccordionItem-module-scss-module__8ZmJjW__fade-in",
  "headline": "AccordionItem-module-scss-module__8ZmJjW__headline",
  "headlineBlock": "AccordionItem-module-scss-module__8ZmJjW__headlineBlock",
  "icon": "AccordionItem-module-scss-module__8ZmJjW__icon",
  "iconFlipped": "AccordionItem-module-scss-module__8ZmJjW__iconFlipped",
  "iconWrapper": "AccordionItem-module-scss-module__8ZmJjW__iconWrapper",
  "innerBlock": "AccordionItem-module-scss-module__8ZmJjW__innerBlock",
  "theme--makers-reserve": "AccordionItem-module-scss-module__8ZmJjW__theme--makers-reserve",
});
